var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.95,
    height: 6,
    viewBox: "0 0 10.95 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_drop_down_FILL0_wght300_GRAD0_opsz24",
    d: "M333.934-544.3l-4.575-4.575a.741.741,0,0,1-.149-.211.584.584,0,0,1-.054-.25.664.664,0,0,1,.18-.464.615.615,0,0,1,.476-.2h9.638a.612.612,0,0,1,.476.2.668.668,0,0,1,.18.464,2.026,2.026,0,0,1-.2.46l-4.575,4.575a1.058,1.058,0,0,1-.326.23.925.925,0,0,1-.37.073.925.925,0,0,1-.37-.073A1.058,1.058,0,0,1,333.934-544.3Z",
    transform: "translate(-329.155 549.999)",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDown);
export default __webpack_public_path__ + "static/media/arrow_drop_down.1a9e6ecc7bc9b7558a1ff3b1956a78e0.svg";
export { ForwardRef as ReactComponent };